/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import Hidden from "@mui/material/Hidden";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { dateFieldDefault, isPhoneNumberDefault, isRequired, pastDateDefault, requiredValidator } from "../../../services/validationRules";
import { useForm } from "../../../provider/Form/FormProvider";
import Person from "../Common/Person/Person";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import Address from "../Common/Address/Address";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import ValidatorDateField from "../../FormFields/ValidatorDateField";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type PetitionerProps = {
  submitProps: FormSubmitProps;
};

export default function Petitioner({ submitProps }: PetitionerProps) {
  const { handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Persönliche Angaben
            </Typography>
          </Hidden>
          <Grid container justifyContent={"flex-start"} alignItems={"baseline"}>
            <Person path="petitioner" showDiverseGenderOption />
            <Grid item xs={12}>
              <ValidatorTextField name="petitioner.birthName" label="Geburtsname (optional)" />
            </Grid>
            <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
              <FormLegend>Wann wurden Sie geboren?</FormLegend>
            </Grid>
            <Grid item xs={12}>
              <ValidatorDateField
                name="petitioner.birthDate"
                label="Geburtsdatum"
                validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault, pastDateDefault]}
              />
            </Grid>
            <Address path="petitioner.addresses[0]" />
            <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
              <FormLegend>Unter welcher Nummer kann man Sie telefonisch erreichen?</FormLegend>
            </Grid>
            <Grid item xs={12} sx={wizardStyle.gridSpace}>
              <ValidatorTextField
                name="telephone"
                label="Telefonnummer"
                autoComplete="tel"
                validators={[
                  {
                    validator: isRequired,
                    message: "Bitte geben Sie Ihre Telefonnummer an",
                  },
                  ...isPhoneNumberDefault,
                ]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
